import React from 'react';
import { useEffect, useState } from 'react';
import { BREAK_POINTS } from 'constants/app';
import { debounce } from 'lodash';

const mapBreakPoint = (width) =>
  Object
    .keys(BREAK_POINTS)
    .reduce((current, key) => {
      return BREAK_POINTS[key] >= width
        ? key
        : current;
    }, 'xl');

export const useWithWidth = () => {
  const [ width, setWith ] = useState(
    mapBreakPoint(window.innerWidth)
  );

  useEffect(() => {
    const onResize = debounce(() => {
      window.requestAnimationFrame(() => {
        let breakPoint = mapBreakPoint(window.innerWidth);

        if (breakPoint !== width) {
          setWith(() => breakPoint);
        }
      });
    }, 25, { maxWait: 1000 });

    window.addEventListener('resize', onResize);

    return () => window.removeEventListener('resize', onResize);
  });

  return [ width ];
};

export default useWithWidth;

export const withWidth = Component => props => {
  const [ width ] = useWithWidth();

  return <Component width={width} {...props} />;
};
